import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[2]} 0 ${space[3]};
`;

export const Title = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const NavControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[2]};
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${semantic.text.primary};
  padding: 0;
  border-radius: 50%;
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const ChipsRow = styled.div`
  display: flex;
  width: 100%;
  gap: ${space[2]};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Chip = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80px;
  border: 1px solid ${semantic.border.subtle};
  background: transparent;
  cursor: pointer;
  padding: ${space[3]} ${space[2]};
  font-family: ${fonts.body};
  border-radius: ${layout.borderRadiusMd};
  transition: background-color 0.15s ease, border-color 0.15s ease;
  flex-shrink: 0;
  gap: ${space[1]};

  &[data-selected] {
    background: ${colors.primary};
    border-color: ${colors.primary};
    color: ${colors.white};
  }

  &:hover:not([data-selected]) {
    background: color-mix(in srgb, ${colors.tertiary} 40%, transparent);
  }
`;

export const ChipTime = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  line-height: 1.3;
  color: ${(p) => (p.$selected ? colors.white : semantic.text.primary)};
`;

export const ChipPrice = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xxs};
  line-height: 1;
  color: ${(p) => (p.$selected ? colors.white : semantic.text.secondary)};
  white-space: nowrap;
`;
